import { Button, Card, CardBody } from '@vnetwork/datacentral-ui/primitives'
import { EmptyState } from '@vnetwork/datacentral-ui/data'
import { useTranslation } from 'react-i18next'
import { AlertError } from '@/components/AlertError'

interface ErrorPageProps {
    status?: number
    error?: Error
}

const ErrorPage = ({ status = 500, error }: ErrorPageProps) => {
    const { t } = useTranslation()
    console.error(error)

    return (
        <Card>
            <CardBody className="space-y-4">
                {error && <AlertError error={error} />}
                <EmptyState
                    title={`${status}!`}
                    description="We seem to have encountered a small issue in answering your question. Please click the back button and try another question."
                    actions={
                        <>
                            <Button
                                size="sm"
                                type="button"
                                onClick={() => window.history.back()}
                            >
                                Go Back
                            </Button>
                            <Button
                                size="sm"
                                type="button"
                                variant="secondary"
                                onClick={() => window.location.reload()}
                            >
                                {t('reload', 'Reload')}
                            </Button>
                        </>
                    }
                />
            </CardBody>
        </Card>
    )
}

export default ErrorPage
